module.exports = __webpack_public_path__ + "img/pphz—icon.cca92584.png";